export default __webpack_public_path__ + "static/pc03-2e7a92fc334c6f1053290d53eebbce63.png";